import { render } from "./RichTextBoxComponent.vue?vue&type=template&id=483156ac&scoped=true&ts=true"
import script from "./RichTextBoxComponent.vue?vue&type=script&lang=ts"
export * from "./RichTextBoxComponent.vue?vue&type=script&lang=ts"

import "./RichTextBoxComponent.vue?vue&type=style&index=0&id=483156ac&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-483156ac"]])

export default __exports__